import { Upload } from 'lucide-react';
import { useFileUpload } from './hooks';

const ImageUploadField = ({ value, onChange, label = 'Image', testId = 'image-upload' }) => {
  const { uploading, uploadFile } = useFileUpload();

  const handleFile = async (file) => {
    const url = await uploadFile(file);
    if (url) onChange(url);
  };

  return (
    <div>
      <label className="font-mono text-xs uppercase tracking-wider mb-1 block">{label}</label>
      <div className="flex gap-2">
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL or upload"
          className="flex-1 border-2 border-gray-300 px-4 py-3 focus:border-black focus:outline-none"
          data-testid={`${testId}-url`}
        />
        <label className="flex items-center gap-2 bg-gray-100 px-4 py-2 cursor-pointer hover:bg-gray-200">
          <Upload size={18} />
          <input
            type="file"
            accept="image/*"
            className="hidden"
            data-testid={`${testId}-file`}
            onChange={(e) => e.target.files[0] && handleFile(e.target.files[0])}
          />
        </label>
      </div>
      {uploading && <p className="font-mono text-xs text-gray-500 mt-1">Uploading...</p>}
      {value && (
        <img src={value} alt="Preview" className="mt-2 w-32 h-32 object-cover" />
      )}
    </div>
  );
};

export default ImageUploadField;
